import React from "react";
import { baseUrl } from '../config/clientsConfig'
import axios from "axios";

const PropertiesService = {
  getpropertyListCount: async () => {
    return axios.get(`${baseUrl}/properties/count`);
  },

   getDocumentType: async (body) =>{
    return axios.post(`${baseUrl}/document-type`, body);
   },

  createProperty: async (propertyData) => {
    return axios.post(`${baseUrl}/property`, propertyData);
  },
  getProperties: async (body) => {
    return axios.post(`${baseUrl}/properties`, body);
  },
  getPropertyById: async (id, propertyTypeId) => {
    return axios.get(
      `${baseUrl}/property/?docId=${id}&propertyTypeId=${propertyTypeId}`
    );
  },
  updateProperty: async (propertyData) => {
    return axios.put(`${baseUrl}/property`, propertyData);
  },




  getUnitsLayoutsByPropertyId: async (id) => {
    return axios.get(`${baseUrl}/units/layouts?docId=${id}`);
  },
  updateLayoutUnit: async (unitData) => {
    return axios.put(`${baseUrl}/units/updateLayout`, unitData);
  },
  createLayoutUnit: async (unitData) => {
    return axios.post(`${baseUrl}/units/createLayout`, unitData);
  },





  createVillaUnit: async (unitData) => {
    return axios.post(`${baseUrl}/units/createVilla`, unitData);
  },
  updateVillaUnit: async (unitData) => {
    return axios.put(`${baseUrl}/units/updateVilla`, unitData);
  },
  getVillaUnitsByPropertyId: async (id) => {
    return axios.get(`${baseUrl}/units/villas?docId=${id}`);
  },




  createTowerInfo: async (towerData) => {
    return axios.post(`${baseUrl}/property/tower`, towerData);
  },
  updateTowerInfo: async (id,towerData) => {
    return axios.put(`${baseUrl}/property/towers/${id}`, towerData);
  },
  getTowerInfoByPropertyId: async (id) => {
    return axios.get(`${baseUrl}/property/towers/${id}`);
  },
  createApartmentUnit : async (unitData) => {
    return axios.post(`${baseUrl}/units/createApartment`, unitData);
  },
  updateApartmentUnit : async (unitData) => {
    return axios.put(`${baseUrl}/units/updateApartment`, unitData);
    },
  getApartmentUnitsByPropertyId : async (id,towerId) => {
    return axios.get(`${baseUrl}/units/apartments?docId=${id}&towerId=${towerId}`);
  }
};

export default PropertiesService;
